import { EVENTS_MAPPING } from '../constants';
import mixpanelService from '../../../shared/services/mixPanel';
import localStorage from './localStorage';

class Tracker {

    initialize(context) {

        this.context = context;
    }

    trackHowFiverrWorksVideo(payload) {
        mixpanelService.trackEvent(
            EVENTS_MAPPING.CLICK.TARGETS.HOW_FIVERR_WORKS_VIDEO,
            payload
        );
    }

    view(categorySlug, title, loggedIn) {
        mixpanelService.trackEvent(
            EVENTS_MAPPING.PAGE_VIEWED.mixpanel,
            {
                'Page Name': 'Category',
                'Category Name': title
            }
        );
        !loggedIn && localStorage.storePageView(categorySlug);
    }
}

export default new Tracker();
